import styles from './PageSizeSelect.module.css';

export const DEFAULT_PAGE_SIZE = 20;

export const PAGE_SIZE_OPTIONS = [
  { value: '12', label: '12' },
  { value: '20', label: '20' },
  { value: '40', label: '40' },
  { value: '60', label: '60' },
];

export function parsePageSize(value) {
  const parsed = parseInt(value || String(DEFAULT_PAGE_SIZE), 10);
  return PAGE_SIZE_OPTIONS.some((opt) => opt.value === String(parsed))
    ? parsed
    : DEFAULT_PAGE_SIZE;
}

export function PageSizeSelect({ value, onChange }) {
  return (
    <div className={styles.wrap}>
      <label htmlFor="pageSize" className={styles.label}>
        На странице
      </label>
      <select
        id="pageSize"
        className={styles.select}
        value={String(value)}
        onChange={(e) => onChange(parsePageSize(e.target.value))}
      >
        {PAGE_SIZE_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
